import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';

export const Container = styled.div`
  position: relative;
`;

function getBorderColor(
  props: { invalid?: boolean; active?: boolean } = {}
): string {
  return props.invalid
    ? colors.red
    : props.active
    ? colors.gray500
    : colors.gray200;
}

export const Input = styled.input<{
  withIcon?: boolean;
  invalid?: boolean;
}>`
  width: 100%;
  border: 1px solid ${({ invalid }) => getBorderColor({ invalid })};
  font-size: 13px;
  line-height: 24px;
  padding: 7px 13px;
  border-radius: 5px;
  ${(props) =>
    props.withIcon
      ? css`
          padding-left: 45px;
        `
      : ''};
  color: ${(props) => (props.invalid ? colors.red : colors.black)};

  &::placeholder {
    color: ${(props) => (props.invalid ? colors.red : colors.black)};
    opacity: 0.5;
  }

  &:focus {
    border-color: ${({ invalid, readOnly }) =>
      getBorderColor({ invalid, active: !readOnly })};
  }
`;

export const prefixCss = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 16px;
  pointer-events: none;
  fill: ${colors.primary};
`;

export const IconComponent = styled.svg`
  ${prefixCss};
`;
